module.exports = __webpack_public_path__ + "img/background.28f56059.png";